import { Component, Input, OnInit } from '@angular/core';
import { InvoiceInterface, InvoiceStatus } from '@contracts/interfaces/invoice.interface';
import { InvoiceComponent } from '../invoice';
import { LineItem } from '@contracts/interfaces/lineitem.interface';


interface HisenseInvoice extends InvoiceInterface {
  serviceOrderNumber: string;
  swapOverNumber: string;
  serviceDate: string;
}

@Component({
  selector: 'app-invoice-hisense',
  templateUrl: './invoice-hisense.component.html',
  styleUrls: ['./invoice-hisense.component.scss', '../../pages/invoice-table.scss']
})
export class InvoiceHisenseComponent extends InvoiceComponent implements OnInit {
  displayedColumns: string[] = ['service-order-number', 'swap-over-number', 'date', 'price', 'actions'];

  @Input()
  invoice: InvoiceInterface;

  prefillLineItems = [
    {
      item: 'Inspection Fee Only',
      desc: "",
      price: 10000,
      qty: 1
    },
    {
      item: 'Travel Allowance',
      desc: "",
      price: 10000,
      qty: 1
    },
    {
      item: '19"-39" In Home Repair',
      desc: "",
      price: 11500,
      qty: 1
    },
    {
      item: '40"-49" In Home Repair',
      desc: "",
      price: 13000,
      qty: 1
    },
    {
      item: '50"-59" In Home Repair',
      desc: "",
      price: 15000,
      qty: 1
    },
    {
      item: '60"-69" In Home Repair',
      desc: "",
      price: 18000,
      qty: 1
    },
    {
      item: '70"-79" In Home Repair',
      desc: "",
      price: 22000,
      qty: 1
    },
    {
      item: '80"+ In Home Repair',
      desc: "",
      price: 25000,
      qty: 1
    },
    {
      item: '19" - 39"+ In Home Replace',
      desc: "",
      price: 10000,
      qty: 1
    },
    {
      item: '40" - 49"+ In Home Replace',
      desc: "",
      price: 10000,
      qty: 1
    },
    {
      item: '50" - 59"+ In Home Replace',
      desc: "",
      price: 13000,
      qty: 1
    },
    {
      item: '60" - 69"+ In Home Replace',
      desc: "",
      price: 15000,
      qty: 1
    },
    {
      item: '70" - 79"+ In Home Replace',
      desc: "",
      price: 22000,
      qty: 1
    },
    {
      item: '80"+ In Home Replace',
      desc: "",
      price: 25000,
      qty: 1
    },
  ]

  defaultInvoice = {
    type: "hisense",
    status: InvoiceStatus.Unpaid,
    customer: {
      business: "Hisense Australia Pty Ltd",
      address: "14 Millenium Court Knoxfield VIC 3180",
      abn: "55 105 022 080",
      email: "service.invoicing@hisense.com",
      name: "",
      phone: "1800 447 367",
      phone2: "",
      notes: "",
      remoteID: "",
      googleReviewSMS: []
    },
    number: null,
    custom: "",
    dateCreated: new Date(),
    dateDue: new Date(),
    subTotal: 0,
    total: 0,
    paymentsMade: [],
    pdf: {
      file: "invoice-hisense"
    },
    lineItems: [
      {
        item: '',
        desc: '',
        qty: 1,
        price: 0
      }
    ],
    gst: 0,
    isGSTIncluded: false,
    communicationLog: []
  }

  childOnInit(): void {
    console.log(this.invoice);
  }
}
